/* const kategoriePozadavkySelect = [
    {
        labelcz: 'ME_POZADAVKY_KATEGORIE_A',
        value: 'A'
    },
    {
        labelcz: 'ME_POZADAVKY_KATEGORIE_B',
        value: 'B'
    }
];
 */
export const kategoriePozadavkySelect = [
    {
        labelcz: 'ME_POZADAVKY_KATEGORIE_B',
        value: 'B'
    },
    {
        labelcz: 'ME_POZADAVKY_KATEGORIE_S',
        value: 'S'
    }
];

export default kategoriePozadavkySelect;
